export function getProductArchivePaginationComponent(idBase) {
    return {
        name: 'ProductArchivePagination',
        props: {
            pages: {
                type: Array,
                required: true,
            },
            current: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                pagesBeforeCurrent: 3,
                pagesAfterCurrent: 3,
            };
        },
        computed: {
            prev() {
                return this.pages[this.current - 2];
            },
            next() {
                return this.pages[this.current];
            },
            first() {
                return this.pages[0];
            },
            last() {
                return this.pages[this.pages.length - 1];
            },
        },
        methods: {
            goTo(pageNo) {
                this.$emit('current-changed', pageNo);
            },
        },
        template: `#${idBase}-pagination`,
    };
}
